import { ChangeEvent, useId, useState } from 'react'
import styles from './Checkbox.module.scss'
import clsx from 'clsx'

export interface CheckboxProps {
    label?: string
    checked?: boolean
    defaultChecked?: boolean
    onChange?: (checked: boolean, e: React.ChangeEvent<HTMLInputElement>) => void
    disabled?: boolean
    required?: boolean
    name?: string
    className?: string
    variant?: 'default' | 'withoutLabel'
}

export const Checkbox = ({
    label,
    checked,
    defaultChecked,
    className,
    onChange,
    disabled,
    required,
    name,
    variant = 'default',
}: CheckboxProps) => {
    const id = useId()
    const [isChecked, setIsChecked] = useState(defaultChecked)

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newChecked = e.target.checked
        if (typeof checked === 'undefined') {
            setIsChecked(newChecked)
        }
        onChange?.(newChecked, e)
    }

    const isControlled = typeof checked !== 'undefined'
    const actualChecked = isControlled ? checked : isChecked
    const showLabel = variant === 'default'

    return (
        <div className={clsx(className, styles.checkboxWrapper)}>
            <input
                type="checkbox"
                id={id}
                checked={actualChecked}
                onChange={handleChange}
                onClick={(event) => event.stopPropagation()}
                disabled={disabled}
                required={required}
                name={name}
                aria-checked={actualChecked}
                aria-required={required}
                className={styles.hiddenInput}
            />

            <label htmlFor={id} className={styles.checkboxLabel}>
                <span
                    role="checkbox"
                    aria-hidden="true"
                    className={clsx(styles.customCheckbox, {
                        [styles.checked]: actualChecked,
                        [styles.disabled]: disabled,
                    })}
                />

                {showLabel && <span className={styles.labelText}>{label}</span>}
            </label>
        </div>
    )
}
